<template>
  <div>
    <b-tabs>
      <b-tab-item :label="`Critical (${critical.length})`">
        <p v-if="!critical.length">No pending orders. Yay!</p>
        <order-card v-for="order in critical" :key="order.docId" :order="order" />
      </b-tab-item>

      <b-tab-item :label="`Todays (${todays.length})`">
        <p v-if="!todays.length">No orders today yet.</p>
        <order-card v-for="order in todays" :key="order.docId" :order="order" />        
      </b-tab-item>

      <b-tab-item :label="`Tomorrows (${tomorrows.length})`">
        <p v-if="!tomorrows.length">No orders for tomorrow.</p>    
        <order-card v-for="order in tomorrows" :key="order.docId" :order="order" />            
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import OrderCard from "./OrderCard";
import OrdersService from "./service";

const initialCount = {
  placed: 0,
  dispatched: 0,
  delivered: 0,
  cancelled: 0
};

export default {
  name: "orders",

  props: ["city"],

  components: {
    OrderCard
  },

  created() {
    this.fetchCriticalOrders();
    this.fetchTodayTomorrowOrders();
  },

  data() {
    return {
      isOpen: false,
      critical: [],
      todays: [],
      tomorrows: [],
      statusCount: initialCount
    };
  },

  methods: {
    fetchCriticalOrders() {
      OrdersService.fetchCriticalOrders(this.city).then(orders => {
        this.critical = orders;
        this.loadingCriticalOrders = false;
      });
    },

    fetchTodayTomorrowOrders() {
      OrdersService.fetchTodayTomorrowOrders(this.city);

      this.$bus.$on("newTodayTomorrowOrdersAvailable", orders => {
        this.todays = orders[0];
        this.tomorrows = orders[1];
        this.countStatus();
        this.loadingTodayTomorrowOrders = false;
      });
    },

    countStatus() {
      this.statusCount = { ...initialCount };

      this.todays.forEach(order => {
        if (order.orderStatus === "PLACED") this.statusCount.placed += 1;
        if (order.orderStatus === "DISPATCHED")
          this.statusCount.dispatched += 1;
        if (order.orderStatus === "DELIVERED") this.statusCount.delivered += 1;
        if (order.orderStatus === "CANCELLED") this.statusCount.cancelled += 1;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cities/Orders/Orders.vue